// exportCard.js — export the ballistic range card to CSV or PDF (field-ready).
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

const csvSafe = (v) => {
  const s = String(v ?? "");
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

const download = (blob, name) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

export function exportCSV({ headers, rows, meta, filename }) {
  const lines = [];
  meta.forEach((m) => lines.push(`${csvSafe(m.label)},${csvSafe(m.value)}`));
  lines.push("");
  lines.push(headers.map(csvSafe).join(","));
  rows.forEach((r) => lines.push(r.map(csvSafe).join(",")));
  download(new Blob(["\uFEFF" + lines.join("\n")], { type: "text/csv;charset=utf-8;" }), `${filename}.csv`);
}

export function exportPDF({ title, headers, rows, meta, filename }) {
  const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });

  doc.setFontSize(16);
  doc.setTextColor(204, 0, 0);
  doc.text(title, 14, 15);

  doc.setFontSize(9);
  doc.setTextColor(70, 70, 70);
  const colW = 68;
  meta.forEach((m, i) => {
    const col = i % 4;
    const row = Math.floor(i / 4);
    doc.text(`${m.label}: ${m.value}`, 14 + col * colW, 24 + row * 5);
  });
  const metaRows = Math.ceil(meta.length / 4);
  const startY = 24 + metaRows * 5 + 3;

  autoTable(doc, {
    head: [headers],
    body: rows,
    startY,
    styles: { fontSize: 8, cellPadding: 1.6 },
    headStyles: { fillColor: [26, 26, 26], textColor: [255, 255, 255], fontStyle: "bold" },
    alternateRowStyles: { fillColor: [244, 244, 245] },
    margin: { left: 14, right: 14 },
  });

  doc.save(`${filename}.pdf`);
}
